export function enumToArray<T = any>(obj: object) {
  return Object.values(obj) as T[];
}
